<script>
  import Multiselect from 'vue-multiselect'
  import {ValidationObserver} from "vee-validate"
  import InputWithValidation from "@components/inputs/InputWithValidation"
  import {tableAction} from '@utils/mixins'

/**
 * Form component
 */
export default {
  components: {
    ValidationObserver,
    InputWithValidation,
    Multiselect
  },
  mixins: [tableAction],
  props: {
    titleModal: {
      type: String,
      default: '',
    },
    refId: {
      type: String,
      default: '',
    },
    inputs: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  data() {
    return {
      title: '',
      totalColumn: 1,
      valueMultiSelect :'',
      totalRow: 1,
      formValue: {},
      inputList: [],
      selectedField: {},
      editField: false,
      innerInputs: []
    }
  },
  computed: {
    formInputs() {
      return this.inputs
    },
    formConfig() {
      return this.$attrs['form-config'] || {
        labelPosition: 'left'
      }
    },
  },
  watch: {
    titleModal: function() {
      this.title = 'Add ' + this.titleModal
    },
    inputs: {
      immediate: true,
      deep: true,
      handler: function(val) {
        this.innerInputs = val
        this.reload()
      }
    },
  },
  created() {
    // this.reload()
    this.inputList = this.splitEvery(this.innerInputs, this.totalColumn, this.totalRow)
    console.log('item.options.list',)
  },
  methods: {
    classColumn(total) {
      return `col-md-${Math.ceil(12 / total)}`
    },
    reload() {
      if (this.innerInputs) {
        this.innerInputs.map((item) => {
          if (item.type === 'column') {
            this.totalColumn = this.totalColumn + 1
          }
          if (item.type === 'row') {
            this.totalRow = this.totalRow + 1
          }
          if (item.name) {
            this.formValue[item.name] = item.value
            if (item.type === 'select') {
              this.selectedField[item.name] = item.value
            }
          }
        })
      }
    },
    addTag (newTag, name) {
      this.$emit('add-tag', {name: name, value: newTag})
    },
    resetForm(id) {
      if (!id) {
        id = 'observer'
      }
      this.inputs.map(item => {
        if (!item.disabled) {
          this.formValue[item.name] = ''
          if(item.type === 'select'){
            this.formValue[item.value] = ''
          }
        }
      })
      requestAnimationFrame(() => {
        this.$refs[id].reset();
      });
      this.$emit('reset-form', this.innerInputs)
    },
    submitForm() {
      this.$emit('submit-form', this.innerInputs)
    },
    updateValue(key, item, val) {
      this.formValue[key] = val
      this.$emit('update-data', {trackBy: key, value: val, formValue: this.formValue})
    },
    updateValueAction(key, item, val, trackBy) {
      this.selectedField[item.name] = val
      this.formValue[item.name] = val
      this.$emit('update-select', {trackBy: trackBy, value: val[trackBy], formValue: this.formValue})
    },
    getFilter(options, val) {
      if (options.list) {
        options.list = this.filteredOptions(options)
        const filtered = options.list.filter(item => {return item[options.trackBy] === val})
        return filtered[0]
      }
    },
    filteredOptions(options) {
      let arr = []
      if (options.list && options.role) {
        options.list.forEach(element => {
          options.role.forEach(role => {
            if (element.roleName === role.roleName && role.access === this.$attrs.user.roleName) {
              arr.push(element)
            } 
          })
        })
      }
      return arr.length > 0 ? arr : options.list
    }
  },
}
</script>

<template>
  <ValidationObserver :ref="refId" v-slot="{ passes }" class="w-100">
    <b-form class="row" @submit.prevent="passes(submitForm)" @reset="resetForm">
      <div v-for="(row, rowIndex) in inputList" :key="rowIndex" class="row w-100 mx-2">
        <div v-if="row.title" class="col-12 mb-3">
          <h4 v-if="row.title.label" class="mb-0 bg-light p-2" :style="row.title.options">{{row.title.label}}</h4>
        </div>
        <div v-for="(col, colIndex) in row.list" :key="colIndex" :class="classColumn(row.list.length)">
          <div v-for="(item, i) in col" :key="i" :style="{ display: item.hidden ? 'none' : 'flex' }" class="row w-100 mx-0 mb-2">
            <div v-if="item.type === 'spacer'" class="col-12 mb-2 pl-0">
              <h4 class="mb-0" :style="item.options">{{item.label}}</h4>
            </div>
            <template v-if="formConfig.labelPosition === 'left'">
              <div v-if="item.type !== 'spacer' && !item.hidden && !item.inputgroup" :style="{ 'min-width': item.options && item.options.width ? item.options.width : '' }" class="col-md-3 pl-0 pt-1">
                <label :for="item.name" class="control-label">{{item.label}}</label>
              </div>
              <div v-if="item.type !== 'spacer' && !item.hidden && !item.inputgroup" :class="{ 'col': true, 'pt-1': item.type === 'checklist' || item.type === 'radio' }">
                <div class="row">{{innerInputs[item.name]}}
                  <InputWithValidation
                    :item="item"
                    :form-value="formValue"
                    :class-div="!formConfig.appendHidden ? 'col-10 pl-0' : 'col-12'"
                    :name="item.name"
                    @update-value="updateValue(item.name, item, $event)">
                    <template v-slot:select-option>
                      <multiselect
                        :value="selectedField[item.name]"
                        :track-by="item.options && item.options.trackBy"
                        :label="item.options && item.options.label"
                        :placeholder="item.placeholder"
                        :show-labels="false"
                        :options="item.options.list ? item.options.list : []"
                        :preselect-first="true"
                        :allow-empty="false"
                        :name="item.name"
                        :disabled="item.disabled"
                        :taggable="item.options && item.options.taggable"
                        class="field-select"
                        @tag="addTag($event, item.name)"
                        @input="updateValueAction(item.name, item, $event, item.options && item.options.trackBy)">
                        <!-- <template v-slot:option="props">
                          <div class="d-flex justify-content-between align-items-center" style="margin: -7px 0">
                            <input v-if="editField" :v-model="props.option.cuName" class="col-10 px-2" />
                            <span v-else class="option__title">{{ props.option.cuName }}</span>
                            <div class="d-flex justify-content-end">
                              <a
                                href="javascript: void(0);"
                                class="btn btn-light btn-xs mr-2"
                                title="Edit"
                                @click="editField = true"
                              ><i class="mdi mdi-pencil font-15" title="Edit" style="cursor: pointer;"></i></a>
                              <a
                                href="javascript: void(0);"
                                class="btn btn-light btn-xs"
                                title="Remove"
                                @click="$emit('delete', { id: props.option.cuId, name: props.option.cuName })"
                              ><i class="mdi mdi-close font-15" title="Remove" style="cursor: pointer;"></i></a>
                            </div>
                          </div>
                        </template> -->
                      </multiselect>
                      <!-- <option v-for="(opt, ix) in $attrs.inputs[1].options" :key="ix" :value="opt.field_id">{{getFieldName(opt.field_id)}}</option> -->
                    </template>
                  </InputWithValidation>
                  <div class="col-2 px-0 pt-1">
                    <span>{{item.append}}</span>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div v-if="item.type !== 'spacer' && !item.hidden && !item.inputgroup" class="col-12 px-0">
                <div class="form-group">
                  <label v-if="!formConfig.labelHidden" :for="item.name" class="control-label">{{item.label}}</label>
                  <div class="row">
                    <InputWithValidation :item="item" :form-value="formValue" :class-div="!formConfig.appendHidden ? 'col-10 px-2' : 'col-12'"
                                         @update-value="updateValue(item.name, item, $event)" />
                    <div class="col-2 d-flex align-self-center px-0">
                      <span>{{item.append}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div v-if="item.hidden" class="col-12 px-0 d-none">
              <div class="form-group">
                <label :for="item.name" class="control-label">{{item.label}}</label>
                <div class="row">
                  <InputWithValidation :item="item" :form-value="formValue" :class-div="'col-10 px-2'"
                                       @update-value="updateValue(item.name, item, $event)" />
                  <div class="col-2 d-flex align-self-center px-0">
                    <span>{{item.append}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="item.inputgroup" class="input-group w-100">
              <InputWithValidation :item="item" :form-value="formValue" :class-div="'col p-0 m-0'" @update-value="updateValue(item.name, item, $event)" />
              <div class="input-group-append p-0 m-0" style="width: max-content; align-self: auto;">
                <div class="w-100">
                  <slot name="append" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <slot name="action" />
      </div>
    </b-form>
  </ValidationObserver>
</template>
